import { connect, MapStateToProps } from 'react-redux';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { isSectionLoading } from '../../../selectors/sections';
import { AppState } from '../../../../types/store';
import { Props } from './SubscriptionsSection';
import { getSectionModuleDataByModuleType } from '../../../selectors/modules';
import { ModuleType } from '../../../../types/modules';

type StateProps = Pick<
  Props,
  'profileOwnerUser' | 'isOwner' | 'hasTiers' | 'isSectionLoading'
>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = state => {
  const { tiers = [] } = getSectionModuleDataByModuleType(
    state,
    'subscriptions',
    ModuleType.TIERS
  );
  return {
    isOwner: isCurrentUserProfileOwner(state),
    hasTiers: tiers.length > 0,
    isSectionLoading: isSectionLoading(state),
    profileOwnerUser: getProfileOwnerUser(state),
  };
};

export default connect(mapStateToProps);
